// eslint-disable-next-line
export default {
    'api': {
        'api': (window.X_API_URL || process.env.REACT_APP_API_URL),
    }
};